// TMP: This file needs review of types, but Infographics v3 is also a task.
// Lets do fixing when infographic is the focus, and not when moving parts
// @ts-nocheck
import tokens from '@gjensidige/builders-tokens/dist/tokens-web.json';

export const parseDataProp = (mountElement) => {
  const table: HTMLTableElement = mountElement.querySelector('table');

  const tooltips: Array<string[]> = [];
  const labels = Array.from(table.rows[0].cells)
    .map((cell: HTMLTableCellElement) => cell.textContent?.trim())
    .slice(1);

  const datasets = Array.from(table.rows)
    .slice(1)
    .map((row: HTMLTableRowElement) => {
      const rowTips: string[] = [];
      tooltips.push(rowTips);

      return Array.from(row.cells).map(
        (cell: HTMLTableCellElement, isTrailing) => {
          const [value, ...tooltip] = cell.innerText.trim().split(/\n\s*\*/);

          // Do not add tooltip for first cell
          if (isTrailing) rowTips.push(tooltip.join('\n').trim());
          return value.trim().split('\n')[0]; // Always only return first row
        }
      );
    });

  const dataRows = datasets.map((row) =>
    row.map((el, index) => {
      if (index === 0) {
        return el; // do not remove whitespace of the <th> of the dataset rows
      } else {
        return el.replace(/\s/gm, '');
      }
    })
  );

  return { labels, tooltips, datasets: dataRows };
};

export const convertArrayToHtml = (labels, datasets) => {
  return `
    <table>
      <thead>
      <tr>
          <th scope="row"></th>
          ${labels.map((label) => `<th>${label}</th>`)}
        </tr>
      </thead>
      <tbody>
        ${datasets.map(
          (dataset) =>
            `<tr><th scope="row"/>${dataset.map(
              (data) => `<td>${data}</td>`
            )}</tr>`
        )}
      </tbody>
    </table>
  `;
};

export const getDatasetForType = (row, index: number) => {
  const colors = [
    tokens.color.purple600,
    tokens.color.blue700,
    tokens.color.blue400
  ];

  return {
    line: {
      label: row[0],
      backgroundColor: tokens.color.white,
      hoverBackgroundColor: tokens.color.purple700,
      data: row.slice(1),
      fill: {
        target: 'origin',
        above: 'rgba(99, 37, 231, 0.10)' // Area will be red above the origin
      },
      borderColor: colors[index] || colors[0],
      borderWidth: 4,
      pointRadius: 5,
      pointHoverRadius: 5,
      pointBorderWidth: 3
    },
    lineWithoutShade: {
      label: row[0],
      backgroundColor: tokens.color.white,
      hoverBackgroundColor: tokens.color.purple700,
      data: row.slice(1),
      borderColor: colors[index] || colors[0],
      borderWidth: 4,
      pointRadius: 5,
      pointHoverRadius: 5,
      pointBorderWidth: 3
    }
  };
};

export const getOptionsForType = (
  dataRows,
  tooltipRows,
  maxTipWidth,
  stacked,
  horizontal,
  numberOfCharts
) => {
  return {
    doughnut: {
      responsive: true,
      plugins: {
        tooltip: {
          enabled: tooltipRows.length > 0,
          callbacks: {
            label: (ctx) => {
              //get the editor provided tooltip labels
              const text = tooltipRows[ctx.datasetIndex][ctx.dataIndex];
              let textLines: string[] = [];
              //must be separated in arrays to break line with chartjs canvas solution
              if (text.length > 30) {
                const splittedList = text.split(' ');
                for (let i = 0; i < splittedList.length; i += maxTipWidth) {
                  textLines = [
                    ...textLines,
                    splittedList.slice(i, i + maxTipWidth).join(' ')
                  ];
                }
              } else if (text.length > 0) {
                textLines = text;
              } else {
                return;
              }
              return tooltipRows.length > 0 ? textLines : ctx.formattedValue;
            }
          }
        }
      }
    },
    bar: {
      plugins: {
        tooltip: {
          enabled: tooltipRows.length > 0,
          callbacks: {
            label: (ctx) => {
              //get the editor provided tooltip labels
              const text = tooltipRows[ctx.datasetIndex][ctx.dataIndex];
              let textLines: string[] = [];
              //must be separated in arrays to break line with chartjs canvas solution
              if (text.length > 30) {
                const splittedList: string[] = text.split(' ');
                for (let i = 0; i < splittedList.length; i += maxTipWidth) {
                  textLines = [
                    ...textLines,
                    splittedList.slice(i, i + maxTipWidth).join(' ')
                  ];
                }
              } else if (text.length > 0) {
                textLines = text;
              } else {
                return;
              }
              return tooltipRows.length > 0 ? textLines : ctx.formattedValue;
            }
          }
        },
        legend: {
          display: dataRows.length > 1
        }
      },
      maintainAspectRatio: false,
      responsive: true,
      maxBarThickness: 150,
      borderSkipped: false,
      scales: {
        x: {
          border: { display: !horizontal },
          stacked: stacked ? true : false,
          display: true,
          ticks: { display: true },
          grid: {
            display: !!horizontal
          }
        },
        y: {
          border: { display: !!horizontal },
          stacked: stacked ? true : false,
          display: numberOfCharts > 2 ? false : true,
          ticks: { display: true },
          grid: {
            display: !horizontal
          }
        }
      },
      indexAxis: horizontal ? 'y' : 'x'
    },
    line: {
      maintainAspectRatio: false,
      responsive: true,
      plugins: {
        legend: {
          display: dataRows.length > 1
        }
      },
      scales: {
        x: {
          stacked: stacked ? true : false,
          display: true,
          ticks: { display: true },
          grid: {
            display: false
          }
        },
        y: {
          border: { display: false },
          stacked: stacked ? true : false,
          display: numberOfCharts > 2 ? false : true,
          ticks: { display: true },
          grid: {
            display: true
          }
        }
      }
    }
  };
};

export const colorPalette = [
  tokens.color.blue700,
  tokens.color.yellow200,
  tokens.color.purple700,
  tokens.color.white,
  tokens.color.blue100,
  tokens.color.blue300,
  tokens.color.success100,
  tokens.color.success200,
  tokens.color.warn100,
  tokens.color.warn200,
  tokens.color.error100,
  tokens.color.error200
];
